import React, { Component } from 'react';
import {
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from 'reactstrap';


class SearchCheckboxes extends Component {
  
  render() {
    const useSECData = this.props.database === 'SecReporting';
    return (
      <>
      {/* <Card className="text-left  mb-2">
        <CardBody> */}
          <Row className='text-left'>
            {useSECData && <Col md={2}>
              <FormGroup>
                <Label>Current Date</Label>
                <Input
                  type="select"
                  name="current_date"
                  onChange={e => this.props.handleDateInputChange(e)}
                  value={this.props.availableDates[this.props.currentDate].date_string}
                >
                  {this.props.availableDates.map(d => (
                    <option key={'current_date_' + d.date_string}>{d.date_string}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>}
            {useSECData && <Col md={2}>
              <FormGroup>
                <Label>Previous Date</Label>
                <Input
                  type="select"
                  name="previous_date"
                  onChange={e => this.props.handleDateInputChange(e)}
                  value={this.props.previousDate !== null ? this.props.availableDates[this.props.previousDate]?.date_string : 'No Comparison'}
                >
                  <option>No Comparison</option>
                  {this.props.availableDates.slice(0, this.props.currentDate).map(d => (
                    <option key={'previous_date_' + d.date_string}>{d.date_string}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>}
            <Col>
              <Row>
                {useSECData && <Col>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="new"
                        checked={this.props.showComparison && this.props.newChecked}
                        onChange={this.props.onChange}
                        disabled={!this.props.showComparison}
                      /> Display New/Existing Column
                    </Label>
                  </FormGroup>
                </Col>}
                {useSECData && <Col>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="toggle_current"
                        onChange={
                          e => this.props.handleToggleCurrent(e)
                        }
                      /> Select All Current
                    </Label>
                  </FormGroup>
                </Col>}
                <Col>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="hasFavorites"
                        checked={this.props.groupSelections.hasFavorites}
                        onChange={e => this.props.onChange(e, ['hasNoFavorites'])}
                      /> Show Favorites
                    </Label>
                  </FormGroup>
                </Col>
                {useSECData && <Col>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="showVerbose"
                        checked={this.props.groupSelections.showVerbose}
                        onChange={this.props.onChange}
                      /> Show Verbose
                    </Label>
                  </FormGroup>
                </Col>}
              </Row>
              <Row>
                {useSECData && <Col>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="is_new"
                        checked={this.props.showComparison && this.props.isNewChecked}
                        onChange={this.props.onChange}
                        disabled={!this.props.showComparison}
                      /> Show Only New Companies
                    </Label>
                  </FormGroup>
                </Col>}
                {useSECData && <Col>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="toggle_previous"
                        /*checked={this.props.showComparison && this.props.isNewChecked}*/
                        onChange={
                          e => this.props.handleTogglePrevious(e)
                        }
                      //disabled={!this.props.showComparison}
                      /> Select All Previous
                    </Label>
                  </FormGroup>
                </Col>}
                <Col>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="hasNoFavorites"
                        checked={this.props.groupSelections.hasNoFavorites}
                        onChange={e => this.props.onChange(e, ['hasFavorites'])}
                      /> Hide Favorites
                    </Label>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="showContacts"
                        checked={this.props.groupSelections.showContacts}
                        onChange={this.props.onChange}
                      /> Show Contacts
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>
        {/* </CardBody>
      </Card> */}
      </>
    );
  }
}

export default SearchCheckboxes;